export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-foot-4f99ab8f416212a3711dfa74dac67608.svg";